"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeAggConnect = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./constants"), exports);
tslib_1.__exportStar(require("./modules"), exports);
tslib_1.__exportStar(require("./utils"), exports);
window[Symbol.for('AggConnectSetup')] = {};
function initializeAggConnect(config) {
    if (!config) {
        throw new Error('AggConnect config not provided');
    }
    window[Symbol.for('AggConnectSetup')] = config;
    Object.freeze(window[Symbol.for('AggConnectSetup')]);
}
exports.initializeAggConnect = initializeAggConnect;
